(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hair-in-motion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hair-in-motion')) {
    /* Abspielen nur pausieren, wenn die Section weiter als NEAR_MARGIN ausserhalb liegt.
       Vorladen des ersten Videos beginnt bei WARM_MARGIN oder nach dem Seiten-Load. */
    const NEAR_MARGIN = 1500;
    const WARM_MARGIN = 2500;
    const WATCHDOG_MS = 1200;
    /* Video-Wechsel: hat das neue Video nach POSTER_GRACE_MS noch kein Bild (nicht vorgeladen, langsames Netz),
       kommt sein Poster nach vorn; nach OUTGOING_PAUSE_MS wird das alte Video angehalten (bleibt als Standbild). */
    const POSTER_GRACE_MS = 2500;
    const OUTGOING_PAUSE_MS = 8000;
    /* Z-58: Im TikTok-In-App-Browser (iOS) oeffnet jeder Start den Vollbild-Player. Dort laedt und startet
       kein Video; die Auswahl wechselt nur Panel und Poster. Flag aus layout/theme.liquid. */
    const noInlineVideo = () => window.zadeyraNoInlineVideo === true;

    customElements.define('hair-in-motion', class extends HTMLElement {
      connectedCallback() {
        this.teardown();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const passive = { signal: this.abort.signal, passive: true, capture: true };
        this.classList.add('is-enhanced');
        this.panels = [...this.querySelectorAll('[data-panel]')];
        this.errorEl = this.querySelector('.hair-motion__error');
        this.lastTime = -1;
        this.querySelectorAll('[data-select]').forEach(button => {
          button.addEventListener('click', () => this.select(button.dataset.select), options);
        });
        this.panels.forEach(panel => this.bindVideo(panel, options));
        this.addEventListener('shopify:block:select', event => this.select(event.detail.blockId), options);
        const resumeFresh = () => this.resume(true);
        document.addEventListener('visibilitychange', () => { if (!document.hidden) this.resume(true); }, options);
        window.addEventListener('pageshow', resumeFresh, options);
        window.addEventListener('focus', resumeFresh, options);
        window.addEventListener('online', resumeFresh, options);
        document.addEventListener('resume', resumeFresh, options);
        /* Blockiertes Autoplay (Stromsparmodus) bei jeder Geste sofort wiederholen. */
        const onGesture = event => {
          if (event.target instanceof Element && event.target.closest('[data-select]') && this.contains(event.target)) return;
          this.resume(true);
        };
        ['touchend', 'click', 'keydown'].forEach(type => document.addEventListener(type, onGesture, passive));
        document.addEventListener('scroll', () => {
          if (!this.warmupStarted && this.measureNear(WARM_MARGIN)) this.beginWarmup();
        }, passive);
        document.addEventListener('shopify:section:unload', event => {
          if (event.target instanceof Node && event.target.contains(this)) {
            this.pauseAll();
            this.teardown();
          }
        }, options);
        if (!noInlineVideo()) this.watchdog = setInterval(() => this.checkPlayback(), WATCHDOG_MS);
        this.setupObservers();
        this.setupProductLinkVisibility();
        this.setupWarmup();
        this.resume(true);
      }
      disconnectedCallback() {
        this.pauseAll();
        this.teardown();
      }
      teardown() {
        this.abort?.abort();
        this.playbackObserver?.disconnect();
        this.warmObserver?.disconnect();
        this.productLinkObserver?.disconnect();
        clearInterval(this.watchdog);
        clearTimeout(this.retryTimer);
        this.cancelTransition();
        this.watchdog = null;
        this.retryTimer = null;
        this.warmupStarted = false;
      }
      bindVideo(panel, options) {
        const video = panel.querySelector('video');
        if (!video) return;
        video.controls = false;
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;
        video._hmOwnPause = false;
        video._hmRevealPending = false;
        const markDecoded = () => { if (video.readyState >= 2) panel.classList.add('is-decoded'); };
        video.addEventListener('loadeddata', markDecoded, options);
        markDecoded();
        video.addEventListener('play', () => {
          if (panel.hidden || !this.isConnected) { this.pauseVideo(video); return; }
          this.revealFirstFrame(panel, video);
        }, options);
        video.addEventListener('playing', () => {
          if (panel.hidden) return;
          panel.classList.add('is-playing');
          video._hmRecoveries = 0;
          this.hideError();
        }, options);
        video.addEventListener('pause', () => {
          panel.classList.remove('is-playing');
          this.cancelReveal(video);
          if (video._hmOwnPause) { video._hmOwnPause = false; return; }
          /* Pause ohne eigenen Ausloeser: iOS-Hintergrund, Stromsparmodus, Audio-Unterbrechung. */
          if (panel.hidden) return;
          if (this.shouldPlay()) this.handleSystemPause(panel);
        }, options);
        /* capture: auch Fehler der <source>-Kinder abfangen (die nicht bubbeln). */
        video.addEventListener('error', event => this.onMediaError(event, panel, video), { signal: options.signal, capture: true });
      }
      setupObservers() {
        if (!('IntersectionObserver' in window)) {
          this.beginWarmup();
          return;
        }
        /* Erster Observer-Aufruf beim Seitenaufbau startet nur, wenn die Section wirklich sichtbar ist;
           sonst wartet das erste Video auf den Seiten-Load (Hero zuerst) oder aufs Scrollen. */
        let initialPlayback = true;
        let initialWarm = true;
        this.playbackObserver = new IntersectionObserver(entries => {
          const entry = entries[entries.length - 1];
          const initial = initialPlayback;
          initialPlayback = false;
          if (entry.isIntersecting) {
            if (!initial || this.measureNear(0)) this.beginWarmup();
            this.resume(true);
          } else if (!document.hidden && !this.measureNear()) {
            this.pauseAll();
          }
        }, { rootMargin: `${NEAR_MARGIN}px 0px` });
        this.playbackObserver.observe(this);
        this.warmObserver = new IntersectionObserver(entries => {
          const initial = initialWarm;
          initialWarm = false;
          if (!entries.some(entry => entry.isIntersecting)) return;
          if (initial && !this.measureNear(0)) return;
          this.warmObserver.disconnect();
          this.beginWarmup();
        }, { rootMargin: `${WARM_MARGIN}px 0px` });
        this.warmObserver.observe(this);
      }
      setupProductLinkVisibility() {
        const stage = this.querySelector('.hair-motion__stage');
        if (!stage || !('IntersectionObserver' in window)) {
          this.classList.add('is-stage-visible');
          return;
        }
        this.productLinkObserver = new IntersectionObserver(entries => {
          this.classList.toggle('is-stage-visible', entries[entries.length - 1].isIntersecting);
        }, { threshold: 0.01 });
        this.productLinkObserver.observe(stage);
      }
      measureNear(margin = NEAR_MARGIN) {
        const rect = this.getBoundingClientRect();
        if (!rect.width && !rect.height) return false;
        const viewport = window.innerHeight || document.documentElement.clientHeight;
        return rect.bottom > -margin && rect.top < viewport + margin;
      }
      shouldPlay() {
        return this.isConnected && !document.hidden && this.measureNear();
      }
      activePanel() {
        return this.panels.find(panel => !panel.hidden) || null;
      }
      resume(fresh = false) {
        if (!this.isConnected || document.hidden) return;
        if (fresh) this.lastTime = -1;
        const panel = this.activePanel();
        if (panel && this.shouldPlay()) this.playVideo(panel);
      }
      handleSystemPause(panel) {
        /* Fremde Pause: sofort neu starten; zweite fremde Pause binnen 250 ms -> nach 350 ms erneut. */
        const now = Date.now();
        if (now - (this.lastImmediateRestart || 0) > 250) {
          this.lastImmediateRestart = now;
          this.playVideo(panel);
          return;
        }
        this.scheduleRetry();
      }
      scheduleRetry() {
        if (this.retryTimer) return;
        this.retryTimer = setTimeout(() => {
          this.retryTimer = null;
          this.resume();
        }, 350);
      }
      checkPlayback() {
        /* Watchdog: pausierte, aber gewollte Wiedergabe neu starten, stehendes Bild anstossen,
           nur weit ausserhalb pausieren. */
        if (!this.isConnected) { this.pauseAll(); this.teardown(); return; }
        if (document.hidden || !this.warmupStarted) return;
        const panel = this.activePanel();
        const video = panel?.querySelector('video');
        if (!video || video.dataset.loaded !== 'true') return;
        if (!this.measureNear()) { this.pauseAll(); this.lastTime = -1; return; }
        if (video.error || video._hmSourceFailed) { this.recover(panel, video); return; }
        if (video.paused) { this.lastTime = -1; this.playVideo(panel); return; }
        if (video.readyState >= 3 && video.currentTime === this.lastTime) {
          /* iOS meldet nach dem App-Wechsel teils "spielt", das Bild steht aber. */
          this.pauseVideo(video);
          this.playVideo(panel);
          this.lastTime = -1;
          return;
        }
        this.lastTime = video.currentTime;
      }
      hydrateVideo(video) {
        if (!video || noInlineVideo()) return;
        if (video.preload !== 'auto') video.preload = 'auto';
        if (video.dataset.loaded === 'true') return;
        /* Nur die HD-MP4 (alle Geraete): wird vollstaendig vorgeladen und haelt in versteckten Panels ihr Bild. */
        const mp4 = video.dataset.videoSrc;
        if (!mp4) return;
        const source = document.createElement('source');
        source.src = mp4;
        source.type = 'video/mp4';
        video.appendChild(source);
        video.dataset.loaded = 'true';
        video.load();
      }
      playVideo(panel, force = false) {
        const video = panel?.querySelector('video');
        if (!video || panel.hidden || !this.isConnected || document.hidden || noInlineVideo()) return;
        if (!force && (!this.warmupStarted || !this.shouldPlay())) return;
        this.hydrateVideo(video);
        if (!video.querySelector('source')) return;
        if (video.error || video._hmSourceFailed) { this.recover(panel, video); return; }
        video.muted = true;
        video.defaultMuted = true;
        if (video.ended) { try { video.currentTime = 0; } catch {} }
        if (!video.paused) return;
        let promise;
        try {
          promise = video.play();
        } catch {
          this.onPlayRejected(panel, video);
          return;
        }
        if (promise && typeof promise.then === 'function') {
          promise.then(() => {
            if (panel.hidden || !this.isConnected) this.pauseVideo(video);
          }, () => this.onPlayRejected(panel, video));
        }
      }
      onPlayRejected(panel, video) {
        if (panel.hidden || !this.isConnected) return;
        if (video.error || video._hmSourceFailed) { this.recover(panel, video); return; }
        /* NotAllowed/Abort: kein Fehlertext; Retry nach 350 ms, danach Watchdog, Gesten und Rueckkehr-Events. */
        this.scheduleRetry();
      }
      recover(panel, video) {
        video._hmRecoveries = (video._hmRecoveries || 0) + 1;
        if (video._hmRecoveries > 3) { this.showError(panel); return; }
        const time = video.currentTime || 0;
        video._hmSourceFailed = false;
        /* load() verwirft das gemalte Bild: Poster wieder darueber, bis der erste neue Frame da ist. */
        this.cancelReveal(video);
        panel.classList.remove('is-started');
        video.addEventListener('loadedmetadata', () => {
          if (time > 0 && Number.isFinite(video.duration)) {
            try { video.currentTime = Math.min(time, Math.max(0, video.duration - 0.2)); } catch {}
          }
        }, { once: true, signal: this.abort.signal });
        video.load();
        if (!panel.hidden && this.shouldPlay()) this.playVideo(panel);
      }
      onMediaError(event, panel, video) {
        if (event.target !== video) {
          const sources = video.querySelectorAll('source');
          if (event.target !== sources[sources.length - 1]) return;
          video._hmSourceFailed = true;
        }
        if (!panel.hidden && this.shouldPlay()) this.recover(panel, video);
      }
      setupWarmup() {
        const start = () => {
          if ('requestIdleCallback' in window) requestIdleCallback(() => this.beginWarmup(), { timeout: 1000 });
          else setTimeout(() => this.beginWarmup(), 300);
        };
        if (document.readyState === 'complete') start();
        else window.addEventListener('load', start, { once: true, signal: this.abort.signal });
      }
      beginWarmup() {
        if (this.warmupStarted || !this.isConnected) return;
        this.warmupStarted = true;
        this.warmPosters();
        this.warmVideos();
        this.resume(true);
      }
      async warmVideos() {
        const signal = this.abort.signal;
        const state = window.__zadeyraHairMotionWarmState ||= { primaryReady: false, allReady: false };
        if (noInlineVideo()) {
          /* Nichts vorzuladen: Wartende (UGC, Z-40) sofort freigeben. */
          this.dataset.primaryReady = 'true';
          if (!state.primaryReady) {
            state.primaryReady = true;
            window.dispatchEvent(new CustomEvent('zadeyra:hair-primary-ready'));
            document.dispatchEvent(new CustomEvent('zadeyra:hair-motion-ready'));
          }
          state.allReady = true;
          window.dispatchEvent(new CustomEvent('zadeyra:hair-all-ready'));
          return;
        }
        const active = this.activePanel() || this.panels[0];
        const order = active ? [active, ...this.panels.filter(panel => panel !== active)] : [];
        for (let index = 0; index < order.length; index++) {
          const panel = order[index];
          await this.warmVideo(panel.querySelector('video'), index === 0);
          if (signal.aborted) return;
          if (index === 0) {
            /* Signal fuer Z-40 (UGC wartet auf window "zadeyra:hair-primary-ready" bzw. den State). */
            this.dataset.primaryReady = 'true';
            if (!state.primaryReady) {
              state.primaryReady = true;
              window.dispatchEvent(new CustomEvent('zadeyra:hair-primary-ready'));
              document.dispatchEvent(new CustomEvent('zadeyra:hair-motion-ready'));
            }
            this.resume();
          }
        }
        state.allReady = true;
        window.dispatchEvent(new CustomEvent('zadeyra:hair-all-ready'));
      }
      warmPosters() {
        /* Alle Poster sofort laden und decodieren, damit sie beim Klick bereitliegen. */
        this.panels.forEach(panel => {
          const poster = panel.querySelector('.hair-motion__poster');
          if (!poster) return;
          poster.loading = 'eager';
          if (typeof poster.decode === 'function') poster.decode().catch(() => {});
        });
      }
      warmVideo(video, primary) {
        if (!video) return Promise.resolve();
        this.hydrateVideo(video);
        if (!video.querySelector('source')) return Promise.resolve();
        /* Erstes Video: canplay reicht (frueh signalisieren). Videos 2-4: vollstaendig vorladen, damit der
           Klick sofort ein Bild hat (canplaythrough, komplett gepuffert oder Browser stoppt das Laden). */
        const fullyBuffered = () => {
          try {
            const ranges = video.buffered;
            return ranges.length > 0 && Number.isFinite(video.duration) && ranges.end(ranges.length - 1) >= video.duration - 0.25;
          } catch { return false; }
        };
        if (video.readyState >= 4 || (primary && video.readyState >= 3) || fullyBuffered()) return Promise.resolve();
        const timeout = primary ? 9000 : 10000;
        return new Promise(resolve => {
          const local = new AbortController();
          const options = { signal: local.signal };
          let timer;
          const done = () => {
            clearTimeout(timer);
            local.abort();
            resolve();
          };
          video.addEventListener('canplaythrough', done, options);
          video.addEventListener('canplay', () => { if (primary) done(); }, options);
          video.addEventListener('progress', () => { if (fullyBuffered()) done(); }, options);
          /* iOS laedt nicht spielende Videos teils nur bis zu einem Puffer und meldet dann suspend. */
          video.addEventListener('suspend', () => { if (video.readyState >= 3) done(); }, options);
          video.addEventListener('error', done, { signal: local.signal, capture: true });
          this.abort.signal.addEventListener('abort', done, options);
          timer = setTimeout(done, timeout);
        });
      }
      revealFirstFrame(panel, video) {
        if (panel.classList.contains('is-started') || video._hmRevealPending) return;
        video._hmRevealPending = true;
        const token = video._hmRevealToken = (video._hmRevealToken || 0) + 1;
        const local = new AbortController();
        video._hmRevealCleanup = () => local.abort();
        const hasFrameCallback = typeof video.requestVideoFrameCallback === 'function';
        const finish = () => {
          if (token !== video._hmRevealToken) return;
          video._hmFrameId = undefined;
          if (!this.isConnected || panel.hidden || video.paused || video.readyState < 2) { this.cancelReveal(video); return; }
          /* Frame vor Abschluss des Seeks auf 0 zaehlt nicht. */
          if (video.seeking) { arm(); return; }
          this.cancelReveal(video);
          panel.classList.add('is-started');
          this.completeTransition(panel);
        };
        const arm = () => {
          if (hasFrameCallback) video._hmFrameId = video.requestVideoFrameCallback(finish);
        };
        arm();
        /* Ohne rVFC (bzw. als Absicherung, falls rVFC nie feuert): Wiedergabe laeuft nachweislich,
           dann zwei Frames warten. */
        const check = () => {
          if (token !== video._hmRevealToken) { local.abort(); return; }
          if (video.paused || video.seeking || video.readyState < 2) return;
          if (hasFrameCallback && !(video.currentTime >= 0.3)) return;
          local.abort();
          requestAnimationFrame(() => requestAnimationFrame(finish));
        };
        ['playing', 'seeked', 'timeupdate'].forEach(type => video.addEventListener(type, check, { signal: local.signal }));
        check();
      }
      cancelReveal(video) {
        if (video._hmFrameId !== undefined) video.cancelVideoFrameCallback?.(video._hmFrameId);
        video._hmFrameId = undefined;
        video._hmRevealCleanup?.();
        video._hmRevealCleanup = undefined;
        video._hmRevealToken = (video._hmRevealToken || 0) + 1;
        video._hmRevealPending = false;
      }
      posterReady(panel) {
        const poster = panel?.querySelector('.hair-motion__poster');
        return Boolean(poster && poster.complete && poster.naturalWidth > 0);
      }
      hasImage(panel) {
        if (!panel) return false;
        if (panel.classList.contains('is-started')) return true;
        return !panel.classList.contains('is-incoming') && this.posterReady(panel);
      }
      startTransition(target, fallback) {
        /* Altes Panel (hidden + is-outgoing) bleibt obenauf sichtbar; das Ziel spielt darunter ohne Poster
           (is-incoming). Erster gemalter Frame des Ziels -> harter Wechsel. Kein Poster, kein Beige. */
        const local = new AbortController();
        const transition = { target, fallback, abort: local, timers: [], posterMode: false };
        this.transition = transition;
        const poster = target.querySelector('.hair-motion__poster');
        const toPoster = () => {
          /* Rueckfall nur bei langsamem Ziel: Poster nach vorn, sobald es decodiert ist, altes Panel weg. */
          if (this.transition !== transition || !transition.posterMode || !this.posterReady(target)) return;
          const finish = () => {
            if (this.transition !== transition) return;
            target.classList.remove('is-incoming');
            fallback.classList.add('is-under');
            this.completeTransition(target);
          };
          if (typeof poster.decode === 'function') poster.decode().then(finish, finish);
          else finish();
        };
        if (poster) poster.addEventListener('load', toPoster, { signal: local.signal });
        transition.timers.push(setTimeout(() => {
          if (this.transition !== transition) return;
          transition.posterMode = true;
          toPoster();
        }, POSTER_GRACE_MS));
        transition.timers.push(setTimeout(() => {
          if (this.transition === transition) this.pauseVideo(fallback.querySelector('video'));
        }, OUTGOING_PAUSE_MS));
        if (target.classList.contains('is-started')) this.completeTransition(target);
      }
      completeTransition(target) {
        const transition = this.transition;
        if (!transition || transition.target !== target) return;
        this.cancelTransition();
        target.classList.remove('is-incoming');
        const fallback = transition.fallback;
        if (fallback === target) return;
        fallback.classList.remove('is-outgoing', 'is-under');
        if (fallback.hidden) this.pauseVideo(fallback.querySelector('video'));
      }
      cancelTransition() {
        const transition = this.transition;
        if (!transition) return;
        this.transition = null;
        transition.timers.forEach(clearTimeout);
        transition.abort.abort();
      }
      pauseVideo(video) {
        if (!video || video.paused) return;
        video._hmOwnPause = true;
        video.pause();
      }
      pauseAll() {
        clearTimeout(this.retryTimer);
        this.retryTimer = null;
        this.panels?.forEach(panel => this.pauseVideo(panel.querySelector('video')));
      }
      select(id) {
        const selected = this.panels.find(panel => panel.dataset.panel === id);
        if (!selected) return;
        const previous = this.activePanel();
        const changed = selected !== previous;
        const video = selected.querySelector('video');
        if (noInlineVideo()) {
          /* Nur Panel und Poster wechseln, kein Video, kein Uebergang. */
          this.cancelTransition();
          this.panels.forEach(panel => {
            panel.hidden = panel !== selected;
            panel.classList.remove('is-outgoing', 'is-under', 'is-incoming');
          });
          this.querySelectorAll('[data-select]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.select === id)));
          this.hideError();
          const stillPoster = selected.querySelector('.hair-motion__poster');
          if (stillPoster) stillPoster.loading = 'eager';
          this.beginWarmup();
          return;
        }
        if (changed) {
          /* Obenauf bleibt das Panel, das gerade wirklich ein Bild zeigt: bei laufendem Wechsel weiterhin
             dessen altes Panel, sonst das bisherige (Frame oder Poster). */
          const pendingFallback = this.transition?.fallback || null;
          let fallback = null;
          if (pendingFallback && pendingFallback !== selected) fallback = pendingFallback;
          else if (this.hasImage(previous)) fallback = previous;
          /* War das Ziel als altes Panel sichtbar, hat sein Video ein gemaltes Bild: kein Poster davor. */
          const keepFrame = selected.classList.contains('is-outgoing') && video?.readyState >= 2 && selected.classList.contains('is-started');
          this.cancelTransition();
          this.panels.forEach(panel => {
            const keep = panel === fallback;
            if (panel !== selected && !keep) this.pauseVideo(panel.querySelector('video'));
            panel.hidden = panel !== selected;
            panel.classList.toggle('is-outgoing', keep);
            panel.classList.remove('is-under');
            panel.classList.toggle('is-incoming', panel === selected && Boolean(fallback));
          });
          if (video) {
            this.cancelReveal(video);
            if (!keepFrame) selected.classList.remove('is-started');
            /* Start am Anfang; Seek nur, wenn das Video schon einmal gelaufen ist. */
            if (video.readyState >= 1 && video.currentTime > 0) {
              try { video.currentTime = 0; } catch {}
            }
          }
          if (fallback) this.startTransition(selected, fallback);
        }
        this.querySelectorAll('[data-select]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.select === id)));
        this.hideError();
        clearTimeout(this.retryTimer);
        this.retryTimer = null;
        this.lastTime = -1;
        const poster = selected.querySelector('.hair-motion__poster');
        if (poster) poster.loading = 'eager';
        /* Synchron im Klick: Nutzergeste bleibt erhalten, kein await davor. */
        this.beginWarmup();
        this.playVideo(selected, true);
        if (video && !video.paused) this.revealFirstFrame(selected, video);
      }
      hideError() {
        if (this.errorEl) this.errorEl.hidden = true;
      }
      showError(panel) {
        panel.classList.remove('is-decoded', 'is-started', 'is-playing');
        if (!panel.hidden && this.errorEl) this.errorEl.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["length-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zadeyra-length-guide')) {
    customElements.define('zadeyra-length-guide', class extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => { if (this.isConnected) this.initialize(); });
      }
      initialize() {
        if (this.initialized) return;
        this.initialized = true;
        this.querySelectorAll('[data-length-available]').forEach((button) => { button.disabled = false; });
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-length]');
          if (!button || button.disabled || !this.contains(button)) return;
          this.select(button);
        });
        this.addEventListener('keydown', (event) => {
          const current = event.target.closest('[data-length]');
          if (!current || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          const buttons = [...this.querySelectorAll('[data-length]:not(:disabled)')];
          if (!buttons.length) return;
          event.preventDefault();
          let index = buttons.indexOf(current);
          if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = buttons.length - 1;
          else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
          buttons[index].focus();
          this.select(buttons[index]);
        });
      }
      select(button) {
        const length = button.dataset.length;
        this.querySelectorAll('[data-length-image]').forEach((image) => { image.hidden = image.dataset.lengthImage !== length; });
        this.querySelectorAll('[data-length]').forEach((choice) => { choice.setAttribute('aria-pressed', String(choice === button)); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zadeyra-faq"] && !Shopify.designMode) return;
  try {
    
  class ZadeyraFaqDialog {
    constructor(root) {
      this.root = root;
      this.dialog = root.querySelector('.zadeyra-faq__dialog');
      this.title = root.querySelector('[data-faq-dialog-title]');
      this.panels = [...root.querySelectorAll('[data-faq-panel]')];
      root.querySelectorAll('[data-faq-category]').forEach((button) => button.addEventListener('click', () => this.open(button)));
      root.querySelector('[data-faq-close]')?.addEventListener('click', () => this.dialog.close());
      this.dialog?.addEventListener('click', (event) => { if (event.target === this.dialog) this.dialog.close(); });
      root.querySelectorAll('.zadeyra-faq__item').forEach((item) => item.addEventListener('toggle', () => this.closeOthers(item)));
    }
    open(button) {
      const category = button.dataset.faqCategory;
      this.title.textContent = button.dataset.faqLabel;
      this.panels.forEach((panel) => { panel.hidden = panel.dataset.faqPanel !== category; });
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
    }
    closeOthers(current) {
      if (!current.open) return;
      this.root.querySelectorAll('.zadeyra-faq__item').forEach((item) => { if (item !== current) item.open = false; });
    }
  }
  const initZadeyraFaq = (scope = document) => scope.querySelectorAll('[data-zadeyra-faq]').forEach((root) => {
    if (!root.zadeyraFaqDialog) root.zadeyraFaqDialog = new ZadeyraFaqDialog(root);
  });
  initZadeyraFaq();
  document.addEventListener('shopify:section:load', (event) => initZadeyraFaq(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zadeyra-real-models"] && !Shopify.designMode) return;
  try {
    
  class RealModelsSlider {
    constructor(root) {
      this.root = root;
      this.slider = root.querySelector('[data-models-slider]');
      this.slides = [...root.querySelectorAll('[data-models-slide]')];
      this.dots = [...root.querySelectorAll('[data-models-dot]')];
      this.reveal = root.querySelector('[data-models-reveal]');
      this.imagesEnabled = false;
      this.index = Math.min(Math.max(Number(root.dataset.initialSlide) || 0, 0), Math.max(this.slides.length - 1, 0));
      this.scrollFrame = null;
      if (!this.slider || this.slides.length < 1) return;
      this.bind();
      this.bindReveal();
      this.bindImageLoading();
      requestAnimationFrame(() => {
        this.goTo(this.index, false);
        this.updateDots(this.index);
      });
    }
    hydrateImage(index) {
      const image = this.slides[index]?.querySelector('[data-model-image]');
      if (!image?.dataset.src) return;
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      if (image.dataset.sizes) image.sizes = image.dataset.sizes;
      image.src = image.dataset.src;
      delete image.dataset.src;
      delete image.dataset.srcset;
      delete image.dataset.sizes;
    }
    hydrateNeighborhood(index) {
      if (!this.imagesEnabled) return;
      const first = Math.max(0, index - 1);
      const last = Math.min(this.slides.length - 1, index + 1);
      for (let current = first; current <= last; current++) this.hydrateImage(current);
    }
    bindImageLoading() {
      const enableImages = () => {
        if (this.imagesEnabled) return;
        this.imagesEnabled = true;
        this.hydrateNeighborhood(this.index);
      };
      if (!('IntersectionObserver' in window)) {
        enableImages();
        return;
      }
      this.imageObserver = new IntersectionObserver((entries, observer) => {
        if (!entries[0]?.isIntersecting) return;
        enableImages();
        observer.disconnect();
      }, { rootMargin: '500px 0px', threshold: 0 });
      this.imageObserver.observe(this.root);
    }
    bindReveal() {
      if (!this.reveal) return;
      if (!('IntersectionObserver' in window)) {
        this.reveal.classList.add('is-reveal-visible');
        return;
      }
      this.reveal.classList.add('is-reveal-ready');
      this.revealObserver = new IntersectionObserver((entries, observer) => {
        if (!entries[0]?.isIntersecting) return;
        this.reveal.classList.add('is-reveal-visible');
        observer.disconnect();
      }, { threshold: 0.08, rootMargin: '0px 0px -10% 0px' });
      this.revealObserver.observe(this.reveal);
    }
    bind() {
      this.slider.addEventListener('scroll', () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.updateDots(this.currentIndex());
        });
      }, { passive: true });
      this.slider.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        this.goTo(this.currentIndex() + direction, true);
      });
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.modelsDot), true)));
      window.addEventListener('resize', () => this.updateDots(this.currentIndex()), { passive: true });
    }
    updateDots(index) {
      this.index = index;
      this.hydrateNeighborhood(index);
      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
    currentIndex() {
      const center = this.slider.scrollLeft + this.slider.clientWidth / 2;
      let active = 0;
      let closest = Infinity;
      this.slides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft + slide.clientWidth / 2 - center);
        if (distance < closest) {
          closest = distance;
          active = index;
        }
      });
      return active;
    }
    goTo(index, smooth) {
      const bounded = Math.max(0, Math.min(index, this.slides.length - 1));
      const slide = this.slides[bounded];
      if (!slide) return;
      this.slider.scrollTo({
        left: slide.offsetLeft - (this.slider.clientWidth - slide.clientWidth) / 2,
        behavior: smooth ? 'smooth' : 'auto'
      });
      this.updateDots(bounded);
    }
  }
  const initRealModelsSliders = (scope = document) => scope.querySelectorAll('[data-real-models-slider]').forEach((root) => {
    if (!root.realModelsSlider) root.realModelsSlider = new RealModelsSlider(root);
  });
  initRealModelsSliders();
  document.addEventListener('shopify:section:load', (event) => initRealModelsSliders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zadeyra-trust-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zadeyra-trust')) {
    customElements.define('zadeyra-trust', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.zadeyra-trust__track');
        this.rail = this.querySelector('[data-rail]');
        this.originalSlides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.desktop = matchMedia('(min-width: 990px)');
        this.themeColorMeta = document.querySelector('meta[name="theme-color"]');
        if (!this.track || !this.rail || !this.originalSlides.length) return;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.active = Math.min(Math.max(Number(this.dataset.initial) || 0, 0), this.originalSlides.length - 1);
        this.scrollSpeed = Math.min(140, Math.max(1, Number(this.dataset.scrollSpeed) || 60));
        this.continuous = this.dataset.continuous === 'true' && this.originalSlides.length > 1;
        this.userPaused = false;
        this.inView = false;
        this.scales = [];
        this.originalSlides.forEach((slide, index) => { slide.dataset.logicalIndex = index; });
        if (this.continuous) this.createLoop();
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.cards = this.slides.map(slide => slide.querySelector('.zadeyra-trust__card'));
        if (this.continuous) this.classList.add('is-continuous');
        this.classList.add('is-enhanced');
        this.querySelector('[data-navigation]').hidden = this.continuous || this.originalSlides.length < 2;
        this.querySelectorAll('[data-open]').forEach(button => { button.hidden = false; });

        this.addEventListener('click', event => {
          if (this.continuous && event.target.closest('.zadeyra-trust__track') === this.track && performance.now() >= (this.ignoreClickUntil || 0)) {
            this.pauseContinuousForClick();
          }
          const button = event.target.closest('[data-open]');
          if (!button || !this.contains(button)) return;
          const dialog = this.querySelector('#' + CSS.escape(button.getAttribute('aria-controls')));
          if (!dialog) return;
          this.dialogTrigger = button;
          this.setDialogBrowserTint();
          if (document.documentElement.classList.contains('safari-26-liquid-glass')) {
            dialog.classList.add('is-modeless');
            dialog.show();
          } else {
            dialog.showModal();
          }
        }, options);
        this.querySelectorAll('dialog').forEach(dialog => {
          dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close(), options);
          dialog.addEventListener('close', () => {
            this.restoreBrowserTint();
            dialog.classList.remove('is-modeless');
            clearTimeout(this.resumeTimer);
            this.resumeWhenIdle = false;
            this.pointerStartX = undefined;
            this.pointerMoved = false;
            this.resumeAfterPageScroll = false;
            this.userPaused = false;
            this.normalizeLoop();
            requestAnimationFrame(() => {
              this.dialogTrigger?.blur();
              this.dialogTrigger = null;
              this.startContinuous();
            });
          }, options);
          dialog.addEventListener('click', event => {
            if (event.target !== dialog) return;
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          }, options);
        });
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.center(index), options));
        this.querySelector('[data-prev]').addEventListener('click', () => this.center(this.active - 1), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.center(this.active + 1), options);
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          this.center(event.key === 'Home' ? 0 : event.key === 'End' ? this.originalSlides.length - 1 : this.active + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        this.track.addEventListener('scroll', () => {
          if (!this.continuous || this.desktop.matches) this.requestMagnification();
          if (this.continuous && (this.userPaused || this.resumeWhenIdle)) this.recordNativeVelocity();
          if (this.resumeWhenIdle) {
            if (this.momentumTakeover) this.syncMomentumTakeover();
            this.queueContinuousResume();
          }
        }, { ...options, passive: true });
        this.track.addEventListener('pointerdown', event => {
          this.pointerStartX = event.clientX;
          this.pointerStartY = event.clientY;
          this.pointerMoved = false;
          this.pointerGestureMoved = false;
          this.resumeAfterPageScroll = false;
        }, options);
        this.track.addEventListener('pointermove', event => {
          if (this.pointerStartX === undefined) return;
          const distanceX = Math.abs(event.clientX - this.pointerStartX);
          const distanceY = Math.abs(event.clientY - this.pointerStartY);
          if (Math.max(distanceX, distanceY) >= 6) this.pointerGestureMoved = true;
          if (this.pointerMoved || distanceX < 6 || distanceX <= distanceY) return;
          this.pointerMoved = true;
          clearTimeout(this.resumeTimer);
          this.resumeWhenIdle = false;
          this.momentumTakeover = false;
          this.userPaused = true;
          this.commitAutoOffset();
          this.stopContinuous();
          this.nativeVelocity = 0;
          this.lastNativeLeft = this.track.scrollLeft;
          this.lastNativeTime = performance.now();
        }, { ...options, passive: true });
        const finishPointer = () => {
          if (this.pointerStartX === undefined) return;
          const hadHorizontalSwipe = this.pointerMoved;
          const hadGestureMovement = this.pointerGestureMoved;
          const shouldResumeAfterPageScroll = this.resumeAfterPageScroll;
          this.pointerStartX = undefined;
          this.pointerStartY = undefined;
          this.pointerMoved = false;
          this.pointerGestureMoved = false;
          this.resumeAfterPageScroll = false;
          if (hadGestureMovement) this.ignoreClickUntil = performance.now() + 350;
          if (shouldResumeAfterPageScroll && !hadHorizontalSwipe) {
            this.userPaused = false;
            this.startContinuous();
            return;
          }
          if (!hadHorizontalSwipe) return;
          this.resumeWhenIdle = true;
          if (this.continuous && hadHorizontalSwipe && !this.desktop.matches && typeof this.rail.animate === 'function') {
            this.beginMomentumTakeover();
          }
          this.queueContinuousResume();
        };
        this.track.addEventListener('pointerup', finishPointer, options);
        this.track.addEventListener('pointercancel', finishPointer, options);
        window.addEventListener('scroll', () => {
          if (!this.continuous || !this.userPaused) return;
          if (this.pointerStartX !== undefined) {
            this.resumeAfterPageScroll = true;
            return;
          }
          this.resumeWhenIdle = false;
          this.userPaused = false;
          this.startContinuous();
        }, { ...options, passive: true });
        this.track.addEventListener('wheel', event => {
          if (event.ctrlKey || Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
          if (this.continuous) {
            this.userPaused = true;
            this.resumeWhenIdle = true;
            this.stopContinuous();
            this.queueContinuousResume();
            return;
          }
          event.preventDefault();
          clearTimeout(this.wheelTimer);
          this.wheelTimer = setTimeout(() => { this.wheelLocked = false; this.wheelDistance = 0; }, 240);
          if (this.wheelLocked) return;
          this.wheelDistance = (this.wheelDistance || 0) + event.deltaX * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? this.track.clientWidth : 1);
          if (Math.abs(this.wheelDistance) < 24) return;
          this.wheelLocked = true;
          this.center(this.active + Math.sign(this.wheelDistance));
        }, { ...options, passive: false });
        this.desktop.addEventListener('change', () => {
          this.commitAutoOffset();
          this.stopContinuous();
          this.requestMagnification(true);
          this.startContinuous();
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const slide = event.target.closest('[data-slide]');
          const index = Number(slide?.dataset.logicalIndex);
          if (Number.isInteger(index)) this.center(index, false, true);
        }, options);
        this.resizeObserver = new ResizeObserver(() => {
          const resumeAnimation = this.autoAnimation?.playState === 'running';
          if (this.autoAnimation) this.commitAutoOffset();
          this.measure();
          this.normalizeLoop();
          this.requestMagnification(true);
          if (resumeAnimation) this.startContinuous();
        });
        this.resizeObserver.observe(this.track);
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.inView = entries[0]?.isIntersecting ?? false;
          if (this.inView) this.startContinuous(); else this.stopContinuous();
        }, { threshold: .05 });
        this.intersectionObserver.observe(this);
        this.measure();
        this.center(this.active, false, true);
      }
      createLoop() {
        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();
        this.leadingSlides = [];
        this.trailingSlides = [];
        for (let copy = 0; copy < 6; copy += 1) {
          this.originalSlides.forEach((slide, index) => this.leadingSlides.push(this.cloneSlide(slide, index)));
          this.originalSlides.forEach((slide, index) => this.trailingSlides.push(this.cloneSlide(slide, index)));
        }
        this.leadingSlides.forEach(slide => before.appendChild(slide));
        this.trailingSlides.forEach(slide => after.appendChild(slide));
        this.rail.insertBefore(before, this.originalSlides[0]);
        this.rail.appendChild(after);
      }
      cloneSlide(slide, index) {
        const clone = slide.cloneNode(true);
        clone.dataset.logicalIndex = index;
        clone.dataset.clone = 'true';
        clone.removeAttribute('id');
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        clone.querySelectorAll('img').forEach(image => {
          image.loading = 'lazy';
          image.fetchPriority = 'low';
        });
        clone.querySelectorAll('a,button,summary,[tabindex]').forEach(node => node.setAttribute('tabindex', '-1'));
        return clone;
      }
      measure() {
        const trackRect = this.track.getBoundingClientRect();
        this.centers = this.slides.map(slide => {
          const rect = slide.getBoundingClientRect();
          return rect.left - trackRect.left + this.track.scrollLeft + (this.autoOffset || 0) + rect.width / 2;
        });
        this.influenceRadius = this.slides[0].offsetWidth * 1.5;
        if (this.continuous && this.trailingSlides?.[0]) {
          this.loopWidth = this.trailingSlides[0].offsetLeft - this.originalSlides[0].offsetLeft;
          this.loopMin = this.originalSlides[0].offsetLeft - (this.track.clientWidth - this.originalSlides[0].offsetWidth) / 2;
        }
      }
      normalizeLoop() {
        if (!this.continuous || !this.loopWidth) return;
        let next = this.track.scrollLeft;
        while (next >= this.loopMin + this.loopWidth) next -= this.loopWidth;
        while (next < this.loopMin) next += this.loopWidth;
        if (Math.abs(next - this.track.scrollLeft) > .5) this.track.scrollLeft = next;
      }
      pauseContinuousForClick() {
        clearTimeout(this.resumeTimer);
        this.resumeWhenIdle = false;
        this.momentumTakeover = false;
        this.userPaused = true;
        this.freezeContinuous();
      }
      recordNativeVelocity() {
        const now = performance.now();
        const elapsed = now - (this.lastNativeTime ?? now);
        const left = this.track.scrollLeft;
        if (elapsed >= 4 && elapsed <= 160) {
          const instantVelocity = (left - (this.lastNativeLeft ?? left)) / elapsed * 1000;
          this.nativeVelocity = Number.isFinite(this.nativeVelocity)
            ? this.nativeVelocity * .35 + instantVelocity * .65
            : instantVelocity;
        }
        this.lastNativeLeft = left;
        this.lastNativeTime = now;
      }
      beginMomentumTakeover() {
        this.momentumTakeover = true;
        this.userPaused = false;
        this.startContinuous();
        this.syncMomentumTakeover();
      }
      syncMomentumTakeover() {
        if (!this.autoAnimation) return;
        const forwardVelocity = Math.max(0, this.nativeVelocity || 0);
        const missingVelocity = Math.max(this.scrollSpeed * .08, this.scrollSpeed - forwardVelocity);
        this.autoAnimation.playbackRate = Math.min(1, missingVelocity / this.scrollSpeed);
      }
      queueContinuousResume() {
        clearTimeout(this.resumeTimer);
        this.resumeTimer = setTimeout(() => {
          if (!this.resumeWhenIdle) return;
          this.resumeWhenIdle = false;
          this.normalizeLoop();
          this.userPaused = false;
          this.startContinuous();
          if (this.autoAnimation) this.autoAnimation.playbackRate = 1;
          this.momentumTakeover = false;
        }, this.momentumTakeover ? 72 : 96);
      }
      startContinuous() {
        if (!this.continuous || this.userPaused || !this.inView || !this.loopWidth) return;
        if (!this.desktop.matches && typeof this.rail.animate === 'function') {
          if (this.autoAnimation) {
            this.autoAnimation.play();
            return;
          }
          const startOffset = this.autoOffset || 0;
          this.animationDuration = this.loopWidth / this.scrollSpeed * 1000;
          this.autoAnimation = this.rail.animate([
            { transform: `translate3d(${-startOffset}px, 0, 0)` },
            { transform: `translate3d(${-startOffset - this.loopWidth}px, 0, 0)` }
          ], {
            duration: this.animationDuration,
            iterations: Infinity,
            easing: 'linear'
          });
          this.rail.style.removeProperty('--trust-auto-offset');
          return;
        }
        if (this.autoFrame) return;
        this.lastAutoTime = null;
        if (!Number.isFinite(this.autoOffset)) this.autoOffset = 0;
        this.autoFrame = requestAnimationFrame(time => this.stepContinuous(time));
      }
      stopContinuous() {
        this.autoAnimation?.pause();
        cancelAnimationFrame(this.autoFrame);
        this.autoFrame = null;
        this.lastAutoTime = null;
      }
      renderedAutoOffset() {
        if (!this.loopWidth) return this.autoOffset || 0;
        const transform = getComputedStyle(this.rail).transform;
        if (!transform || transform === 'none') return this.autoOffset || 0;
        let offset;
        try {
          offset = -new DOMMatrixReadOnly(transform).m41;
        } catch (_) {
          const values = transform.match(/^matrix(?:3d)?\((.+)\)$/)?.[1].split(',').map(Number);
          offset = values?.length === 16 ? -values[12] : -(values?.[4] || 0);
        }
        if (!Number.isFinite(offset)) return this.autoOffset || 0;
        return ((offset % this.loopWidth) + this.loopWidth) % this.loopWidth;
      }
      freezeContinuous() {
        if (this.autoAnimation) {
          this.autoOffset = this.renderedAutoOffset();
          this.rail.style.setProperty('--trust-auto-offset', `${-this.autoOffset}px`);
          this.autoAnimation.cancel();
          this.autoAnimation = null;
        }
        cancelAnimationFrame(this.autoFrame);
        this.autoFrame = null;
        this.lastAutoTime = null;
      }
      commitAutoOffset() {
        let offset = this.autoOffset || 0;
        if (this.autoAnimation) {
          offset = this.renderedAutoOffset();
          this.autoAnimation.cancel();
          this.autoAnimation = null;
        }
        if (!offset) return;
        this.track.scrollLeft += offset;
        this.autoOffset = 0;
        this.rail.style.removeProperty('--trust-auto-offset');
        this.normalizeLoop();
      }
      stepContinuous(time) {
        if (!this.autoFrame) return;
        const elapsed = Math.min(40, Math.max(0, time - (this.lastAutoTime ?? time)));
        this.lastAutoTime = time;
        this.autoOffset += this.scrollSpeed * elapsed / 1000;
        while (this.autoOffset >= this.loopWidth) this.autoOffset -= this.loopWidth;
        this.rail.style.setProperty('--trust-auto-offset', `${-this.autoOffset}px`);
        if (this.desktop.matches) this.requestMagnification();
        this.autoFrame = requestAnimationFrame(nextTime => this.stepContinuous(nextTime));
      }
      requestMagnification(immediate = false) {
        if (immediate) {
          cancelAnimationFrame(this.scrollFrame);
          this.paintMagnification(performance.now(), true);
        } else if (!this.scrollFrame) {
          this.scrollFrame = requestAnimationFrame(time => this.paintMagnification(time));
        }
      }
      paintMagnification(time, immediate = false) {
        this.scrollFrame = null;
        const middle = this.track.scrollLeft + this.track.clientWidth / 2 + (this.autoOffset || 0);
        const elapsed = Math.min(64, Math.max(1, time - (this.lastFrameTime ?? time - 16)));
        const blend = immediate ? 1 : 1 - Math.exp(-elapsed / 65);
        let nearest = 0, distance = Infinity, settling = false;
        const nextScales = this.centers.map((center, index) => {
          const currentDistance = Math.abs(center - middle);
          if (currentDistance < distance) { nearest = index; distance = currentDistance; }
          const proximity = Math.min(1, currentDistance / this.influenceRadius);
          const influence = (1 + Math.cos(Math.PI * proximity)) / 2;
          const target = .85 + .15 * influence;
          const previous = this.scales[index] ?? target;
          const next = previous + (target - previous) * blend;
          if (Math.abs(target - next) > .00015) settling = true;
          return Math.abs(target - next) <= .00015 ? target : next;
        });
        if (!this.renderedScales) this.renderedScales = [];
        nextScales.forEach((scale, index) => {
          if (Math.abs((this.renderedScales[index] ?? -1) - scale) < .0001) return;
          this.cards[index].style.setProperty('--trust-scale', scale.toFixed(5));
          this.renderedScales[index] = scale;
        });
        this.scales = nextScales;
        this.update(nearest);
        this.lastFrameTime = settling ? time : null;
        if (settling) this.scrollFrame = requestAnimationFrame(nextTime => this.paintMagnification(nextTime));
      }
      update(index) {
        const logicalIndex = Number(this.slides[index]?.dataset.logicalIndex) || 0;
        this.active = logicalIndex;
        if (this.renderedPhysical === index) return;
        this.renderedPhysical = index;
        this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
        this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === logicalIndex)));
        this.querySelector('[data-prev]').disabled = false;
        this.querySelector('[data-next]').disabled = false;
      }
      center(index, animate = true, preferOriginal = false) {
        const count = this.originalSlides.length;
        index = ((index % count) + count) % count;
        const candidates = preferOriginal ? [this.originalSlides[index]] : this.slides.filter(slide => Number(slide.dataset.logicalIndex) === index);
        const trackRect = this.track.getBoundingClientRect();
        let targetSlide = candidates[0];
        let targetLeft = Infinity;
        let nearestDistance = Infinity;
        candidates.forEach(slide => {
          const rect = slide.getBoundingClientRect();
          const left = this.track.scrollLeft + rect.left + rect.width / 2 - trackRect.left - trackRect.width / 2;
          const distance = Math.abs(left - this.track.scrollLeft);
          if (distance < nearestDistance) { nearestDistance = distance; targetSlide = slide; targetLeft = left; }
        });
        if (!targetSlide) return;
        if (!Number.isFinite(targetLeft)) {
          const rect = targetSlide.getBoundingClientRect();
          targetLeft = this.track.scrollLeft + rect.left + rect.width / 2 - trackRect.left - trackRect.width / 2;
        }
        this.track.scrollTo({ left: targetLeft, behavior: animate ? 'smooth' : 'instant' });
        this.requestMagnification(!animate);
      }
      setDialogBrowserTint() {
        if (!document.documentElement.classList.contains('safari-26-liquid-glass') || !this.themeColorMeta) return;
        this.previousThemeColor = this.themeColorMeta.getAttribute('content') ?? '';
        this.themeColorMeta.setAttribute('content', '#efe1ce');
      }
      restoreBrowserTint() {
        if (this.previousThemeColor === undefined || !this.themeColorMeta) return;
        this.themeColorMeta.setAttribute('content', this.previousThemeColor);
        this.previousThemeColor = undefined;
      }
      disconnectedCallback() {
        this.restoreBrowserTint();
        this.stopContinuous();
        this.autoAnimation?.cancel();
        this.controller?.abort();
        clearTimeout(this.wheelTimer);
        clearTimeout(this.resumeTimer);
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        cancelAnimationFrame(this.scrollFrame);
        this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
